import {InjectionToken} from "@angular/core";
import {AppConfig} from "./AppConfig";

export const APP_CONFIG: InjectionToken<AppConfig> = new InjectionToken<AppConfig>('Application Configuration');

export const ENVIRONMENT_FILE_PATH="environments/environment.json";

export const TIMEOUT_RETRIEVE_ENVIRONMENT=7000;
